import { render, staticRenderFns } from "./provLogoEdit.vue?vue&type=template&id=44352916&scoped=true"
import script from "./provLogoEdit.vue?vue&type=script&lang=js"
export * from "./provLogoEdit.vue?vue&type=script&lang=js"
import style0 from "./provLogoEdit.vue?vue&type=style&index=0&id=44352916&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44352916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44352916')) {
      api.createRecord('44352916', component.options)
    } else {
      api.reload('44352916', component.options)
    }
    module.hot.accept("./provLogoEdit.vue?vue&type=template&id=44352916&scoped=true", function () {
      api.rerender('44352916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/logoSet/provLogoEdit.vue"
export default component.exports